<template>
    <div>
        <v-select
            v-model="item"
            :items="items"
            label="Status"
            outlined
            @change="inputChange"
            @focus="inputFocus"
            @blur="inputBlur"
            :loading="loading"
            :disabled="disabled"
        ></v-select>
    </div>
</template>

<script>
import { showInfoSnackBar, showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import { mapActions, mapGetters } from "vuex";

export default {
    name: "StatusOptionsField",
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        noRule: {
            type: Boolean,
            default: false,
        },
    },
    components: {

    },
    data: () => ({
        items: [
            'Instalado',
            'Não se Instala',
            'Não Autorizado',
            'Desativado',
            'Pendente',
            'Revisado',
        ],
        item: null,
        focus: false,
    }),
    methods: {
        inputChange() {
            this.emitLoading(true)
            this.emitDisabled(true)
            this.emitInput()
        },
        inputFocus() {
            this.focus = true
            this.emitFocus(this.focus)
        },
        inputBlur() {
            this.focus = false
            this.emitFocus(this.focus)
        },
        emitLoading(status) {
            this.$emit('loading:input', status)
        },
        emitDisabled(status) {
            this.$emit('disabled:input', status)
        },
        emitFocus(status) {
            this.$emit('focus:input', status)
        },
        emitInput() {
            this.$emit('change:input', this.item)
            this.emitLoading(false)
            this.emitDisabled(false)
            this.emitFocus(false)
        }
    },
    computed: {
        
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newVal) {
                if (newVal) {
                    this.item = newVal
                }
            }
        },
    }
};
</script>